import i18n from "i18next";
import config from "./config";
import translations from "./translations";
i18n.init({
  resources: translations,
  fallbackLng: "en",
  debug: false,
  lng: config.appLanguage.replaceAll("-", "_"),
  ns: ["translations"],
  defaultNS: "translations",
  keySeparator: false,
  interpolation: {
    escapeValue: false, // not needed for react!!
    formatSeparator: ",",
  },
  react: {
    wait: true,
  },
});

export default i18n;
